import styled from 'styled-components';
import { Content, Root, Trigger } from '@radix-ui/react-dropdown-menu';
import { Fieldset } from '../../../baseComponents/inputs/Fieldset';
import { Radio } from '../../../baseComponents/inputs/Radio';
import { TypographyStyles, accordionAnimation, colours, media, spacing, zProductBadge } from '../../../stylings';

export const Container = styled(Root)`
  display: none;

  @media ${media.greaterThan('lg')} {
    display: flex;
  }
`;

export const TriggerButton = styled(Trigger)`
  align-items: center;
  background-color: ${colours.WHITE};
  border: 1px solid ${colours.GREY};
  color: ${colours.BLACK};
  display: none;
  margin-left: auto;
  min-height: 48px;
  padding: 9px ${spacing.XS};
  width: 220px;
  ${TypographyStyles.Body.Medium.SemiBold}

  .accordion-arrow-down {
    flex-shrink: 0;
    transition: transform 0.3s cubic-bezier(0.87, 0, 0.13, 1);
  }

  &[data-state='open'] {
    > .accordion-arrow-down {
      transform: rotate(180deg);
    }
    color: ${colours.MIDNIGHT_BLUE};
    width: 220px;
  }
  &:focus,
  &:hover {
    background-color: ${colours.LIGHT_BLUE};
  }

  @media (prefers-reduced-motion) {
    .accordion-arrow-down {
      transition: none;
    }
  }

  @media ${media.greaterThan('lg')} {
    display: flex;
  }
`;

export const Label = styled.label`
  align-items: center;
  color: ${colours.BLACK};
  cursor: pointer;
  display: flex;
  width: 100%;
  ${TypographyStyles.Body.Medium.SemiBold}
`;

export const RadioGroup = styled(Fieldset)<{ $isDropDownOpen: boolean }>`
  background-color: ${colours.WHITE};
  border-top: none;
  display: none;
  margin: 0;
  padding: 0;

  .checked {
    ${TypographyStyles.Body.Tiny.SemiBold}
  }

  > div {
    &:focus {
      background-color: ${colours.LIGHT_BLUE};
      outline-color: ${colours.OUTLINE_BORDER};
      outline-width: 2px;
    }

    &:hover {
      outline: none;
    }
  }

  @media ${media.greaterThan('lg')} {
    display: block;
  }
`;

export const RadioButton = styled(Radio)<{ $isDropDownOpen: boolean }>`
  ${TypographyStyles.Body.Tiny.Medium}
  border: none;
  gap: ${spacing.XXXXS};
  height: 100%;
  min-height: 38px;
  padding: ${spacing.XXXS};
  width: 100%;
  &:hover,
  &:focus-within {
    background-color: ${colours.LIGHT_BLUE};
    outline-color: ${colours.OUTLINE_BORDER};
    outline-width: 2px;
  }
  ${({ $isDropDownOpen }) => accordionAnimation($isDropDownOpen)}
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
`;

export const Button = styled.button`
  align-items: center;
  background-color: ${colours.WHITE};
  border: 1px solid ${colours.GREY};
  color: ${colours.BLACK};
  display: flex;
  height: 44px;
  padding: 9px ${spacing.XS};
  width: 160px;
`;

export const Header = styled.span`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.L};
  width: 268px;
  h4 {
    ${TypographyStyles.Headings.H4}
    font-weight: 600;
    height: 18px;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    width: 232px;
  }
`;

export const CloseButton = styled.button`
  background-color: inherit;
  border: none;
  svg {
    height: 10px;
    width: 10px;
  }
`;

export const DropdownContent = styled(Content)<{ $isDropDownOpen: boolean }>`
  border: solid 1px ${colours.BLACK};
  ${({ $isDropDownOpen }) => accordionAnimation($isDropDownOpen)}
  overflow: hidden;
  width: 220px;

  z-index: ${zProductBadge};
`;
